import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPosCompanyRequest } from '../models/models'
import { CommonPostResponse } from '../../../components/models/models'

export class UpdatePosCompanyApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransaction/updatePosCompany',
      requesterInfo,
    })
  }

  public async updatePosCompany(request: IPosCompanyRequest): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}